<template>
    <div class="slides__slide options grid-container">
        <div class="grid-x grid-padding-x align-center">
            <div class="cell medium-20 large-12">
                <div class="text-content">
                    <div class="stepCounter">
                        <span class="stepCounter__from">{{ slidedata.step }}</span>
                        <span class="stepCounter__to">{{ slidedata.stepOf }}</span>
                    </div>

                    <h1>{{ slidedata.title }}</h1>
                    <p v-html="slidedata.text" />
                </div>

                <ul class="option-list">
                    <li v-for="(option, index) in slidedata.options" :key="index" :class="{
                        'disabled': option.disabled,
                        'enabled': !option.disabled
                    }">
                        <label :title="available(option.disabled)">
                            <figure :style="`background-image: url('${option.figure}')`"></figure>
                            <span class="btn">{{ option.title }}<i class="icon-arrow-right"></i></span>
                            <input type="radio" v-model="model" :name="option.name" :value="option.value" v-if="!option.disabled" />
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: null,
        };
    },
    watch: {
        model() {
            this.$emit('nextStep', {
                [this.slidedata.name]: this.model,
            });
        },
    },
    props: {
        slidedata: {
            default() {
                return {};
            },
            type: Object,
        },
    },
    methods: {
        available(available) {
            if (!available) {
                return window.translations.notAvailable;
            }

            return '';
        },
    },
};
</script>
